import { MediaEditor } from "@/components/ui/mediaEditor/mediaEditor";
import { useParams } from "react-router-dom";

export function MediaLibrary(props) {
  const { patientId } = useParams();
  return (
    <MediaEditor apiPrefix={`/api/user/${patientId}/media`} privateLibrary />
  );
}
